import { render, staticRenderFns } from "./WebsiteUnitTypeTable.vue?vue&type=template&id=4ca53ba7&scoped=true&"
import script from "./WebsiteUnitTypeTable.vue?vue&type=script&lang=js&"
export * from "./WebsiteUnitTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca53ba7",
  null
  
)

export default component.exports